import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render judging criteria section for FAQ Page
 */
const JudgingCriteriaSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="judging-criteria-section-component"
    >
      <AccordionV2
        testId="judging-criteria"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="What are the selection and judging criteria for each award?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-2 px-6 py-4 pb-0">
          <p>
            The selection and judging criteria are specific to each award.
            Please go to the specific award page for these criteria:
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Best Managed Board;</li>
            <li>Best Chief Executive Officer;</li>
            <li>Best Chief Financial Officer;</li>
            <li>Best Risk Management;</li>
            <li>Best Investor Relations;</li>
            <li>Best Annual Report;</li>
            <li>Special Recognition;</li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default JudgingCriteriaSection;
